import { render } from "./Sorting.vue?vue&type=template&id=7138d289&scoped=true"
import script from "./Sorting.vue?vue&type=script&lang=js"
export * from "./Sorting.vue?vue&type=script&lang=js"

import "./Sorting.vue?vue&type=style&index=0&id=7138d289&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7138d289"]])

export default __exports__